import axios from 'axios'

export const TagInsightApi = {
    http: axios.create(),
    async getPremiumInsightInfo(request) {
        return this.http.get(Routing.generate('tag_category_info', request));
    },
    async getReportTagInfo(request) {
        return this.http.get(Routing.generate('get_report_tags', request));
    }
}
